import React, { createContext, useState, useEffect } from 'react';
import axios from 'axios';

export const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cartItemCount, setCartItemCount] = useState(0);

  // Fonction utilitaire pour compter les articles à partir d'un tableau
  const countItemsFromArray = (cartItems) => {
    if (Array.isArray(cartItems)) {
      const totalCount = cartItems.reduce((acc, item) => acc + (item.quantity || 0), 0);
      setCartItemCount(totalCount);
    } else {
      console.error("cartItems n'est pas un tableau :", cartItems);
      setCartItemCount(0);
    }
  };

  // Fonction principale pour mettre à jour le nombre d'articles
  const updateCartItemCount = async (cartItems = null) => {
    if (Array.isArray(cartItems)) {
      countItemsFromArray(cartItems);
      return;
    }

    const token = localStorage.getItem('auth_token');
    if (!token) {
      setCartItemCount(0);
      return;
    }

    try {
      const response = await axios.get('https://madadline.com/api/cart', {
        headers: { Authorization: `Bearer ${token}` },
      });

      const cart = response.data;
      localStorage.setItem('cart', JSON.stringify(cart));
      countItemsFromArray(cart);
    } catch (error) {
      console.error("Erreur lors de la récupération du panier :", error);
      setCartItemCount(0);
    }
  };

  // Chargement initial à partir du localStorage
  useEffect(() => {
    const storedCart = localStorage.getItem('cart');
    if (storedCart) {
      try {
        const cartItems = JSON.parse(storedCart);
        updateCartItemCount(cartItems); // mise à jour locale
      } catch (error) {
        console.error("Erreur lors du parsing du panier :", error);
        localStorage.removeItem('cart');
        setCartItemCount(0);
      }
    } else {
      // Aucun panier local → on tente de charger depuis l'API si connecté
      updateCartItemCount();
    }
  }, []);

  return (
    <CartContext.Provider value={{ cartItemCount, updateCartItemCount }}>
      {children}
    </CartContext.Provider>
  );
};
